import React, { useRef } from 'react';
import { Space, Button, Row, Col, Tooltip } from 'antd';
import TableFetchData from '../../components/data-table/TableFetchData';
import MagazineCard from '../../components/magazine/MagazineCard';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import { useTranslation } from 'react-i18next';
import MagazineModal from '../../components/magazine/MagazineModal';
import { useNavigate } from 'react-router-dom';
import { secondsToTime, sliceWord20character } from '../../utils/string';
import { VideoThumbnail } from '../../components/upload/DragUploadTeacherComponentVideo';

const TableListEducationCourseTeacher = ({ 
  viewType, magazineData, tableParams,
   setTableParams, loading, setLoading,
   hadleUpdateMagazine, deleteMagazineData, 
   toggleView, teacherId, callData
}) => {
  const { t } = useTranslation();
  const maxLength = 20
  // new code for view pdf
  const magazineRef = useRef();
  const appDownloadRef = useRef();
  const navigate = useNavigate();
  const handleShowMagazine = async (item) => {
    magazineRef.current?.showModal(item);
  };
  const handleCloseDownloadApp = () => appDownloadRef.current?.closeModal();

  const tableSettings = {
    appendable: false,
    removable: false,
    bordered: true,
    size: "small",
    pagination: {
      showLessItems: true,
      pageSize: 10,
    },
    columns: [
      {
        title: <label className="titleCard14400">{t("Video")}</label>,
        render: (_, record) => (
          <>
            <VideoThumbnail isview={true} url={record && record.videoFile} it={{...record,
              url: record.videoFile,
              thumbnail: record.picUrl,
            }} />
          </>
        )
      },
      {
        title: <label className="titleCard14400">{t("Title Course")}</label>,
        render: (_, record) => {
          return <Tooltip title={sliceWord20character(record && record.title)}>
            {sliceWord20character(record && record.title).length > maxLength ? sliceWord20character(record && record.title).slice(0, maxLength) + "..." : sliceWord20character(record && record.title)}
          </Tooltip>
        }
      },
      {
        title: <label className="titleCard14400">{t("Course Description")}</label>,
        render: (_, record) => {
          return <Tooltip title={sliceWord20character(record && record.intro)}>
            {sliceWord20character(record && record.intro).length > maxLength ? sliceWord20character(record && record.intro).slice(0, maxLength) + "..." : sliceWord20character(record && record.intro)}
          </Tooltip>
        }
      },
      {
        title: <label className="titleCard14400">{t('Category')}</label>,
        render: (_, record) => (
          <Button disabled className='me-2'
            style={{
              cursor: 'default',
              fontSize: '12px',
              backgroundColor: "#F8E2E8",
              border: "none",
              color: "#E50A47",
              height: "21px"
            }}
          >{record && record?.categoryId && record?.categoryId?.name}</Button>
        )
      },
      {
        title: <label className="ant-table-column-title titleCard14400">{t('Course validity period')}</label>,
        key: 'privateFile.uploadedTS',
        render: (_, record) => (
          <label className="text-capitalize">{record && record?.validityPeriod + " " + t("day")}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Course Amount')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{"¥ " + (record?.price ?? "")}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Course duration')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{secondsToTime(record?.videoDuration) ?? ""}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Collection')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{record?.favorite ?? 0}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Number of purchases')}</label>,
        render: (_, record) => {
          const courseId = record?.courseId || record?.courseNo || record?._id;
          return (
            <a
              className="text-capitalize"
              onClick={() => navigate(courseId ? `/course-purchase?courseId=${courseId}` : '/course-purchase')}
            >
              {record?.purchaseCount ?? 0}
            </a>
          );
        }
      },
      {
        title: <label className="titleCard14400">{t('Create an account')}</label>,
        render: (_, record) => (
          <label className="text-capitalize">{record?.createdBy?.name ?? ""}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Operator')}</label>,
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <span style={{ cursor: "pointer" }} onClick={() => navigate(`/education-course/upload/${record._id}?id=${teacherId}`)}>
              <EditTableSvg />
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => deleteMagazineData(record)}>
              <DeleteTableSvg />
            </span>
          </Space>
        ),
      },
    ],
  };

  return (
    <div>
      <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
        <Col style={{ marginLeft: 'auto' }}>
        </Col>
      </Row>

      {viewType === 'table' ? (
        <TableFetchData
          tableParams={tableParams}
          setTableParams={setTableParams}
          data={magazineData}
          columns={tableSettings.columns}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <MagazineCard 
          magazineData={magazineData} setLoading={setLoading} 
          loading={loading} tableParams={tableParams}
          tableSettings={tableSettings}
          setTableParams={setTableParams}
          hadleUpdateMagazine={hadleUpdateMagazine}
          deleteMagazineData={deleteMagazineData}
          handleShowMagazine={handleShowMagazine}
          navigate={navigate}
          t={t}
        />
      )}
      <MagazineModal
        ref={magazineRef}
        handleCloseDownloadApp={handleCloseDownloadApp}
      />
    </div>
  );
};

export default TableListEducationCourseTeacher;
